import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'src/rerouter';
import type {ReferralFormParam} from 'src/types/referral-external';
import {selectFormData} from 'src/selectors/referral-external';
import {AnalyticsService} from 'src/analytics';
import {
  Button,
  BodyMedium,
} from '@spaced-out/ui-design-system/lib/components/index';
import {
  getReferralUrlSegment,
  getReferrerPortalLink,
  CUSTOMER_TYPE,
} from 'src/utils/referral-external';
import {selectUserAgent} from 'src/selectors/accounts';
import * as api from 'src/utils/redux-api-v2';
import {isMobile} from 'src/utils/responsive';
import ReferSuccess from 'src/images/refer-success.svg';
import css from 'src/components/referral-external/refer-success.css';


export const Success = (params: ReferralFormParam) => {
  const {t} = useLabelTranslation();
  const router = useHistory();
  const userAgent = useSelector(selectUserAgent);

  const dispatch = useDispatch();
  const {is_tracking_enabled, track_referral_by_email, customer_type} =
    useSelector(selectFormData);

  const {token, sourceEmail, referralLinkId} = params;

  const onTrackReferrals = async () => {
    if (track_referral_by_email && isMobile(userAgent)) {
      router.push({
        pathname: getReferralUrlSegment(referralLinkId),
        query: {action: 'track'},
      });
      return;
    }
    const response: 'agent' | 'other' = await dispatch(
      api.get(`referral/external/user/track-referral-url`, {
        email: sourceEmail,
      }),
    );
    // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
    AnalyticsService.track('referral tracked');

    const senseReferralTrackingUrl = `${window.location.origin}/referralv2/tracking/all-referrals`;
    const referrerPortalUrl = `${getReferrerPortalLink()}?email=${encodeURIComponent(
      sourceEmail ?? '',
    )}`;

    const trackingUrl =
      response === 'agent' ? senseReferralTrackingUrl : referrerPortalUrl;

    window.open(trackingUrl, '_blank');
  };

  return (
    <div className={css.container}>
      <ReferSuccess />
      {!token ? (
        <div>
          {is_tracking_enabled ? (
            <>
              <BodyMedium>{`${t(
                'Thank_you_for_submitting_your_referral_We_will_keep_you_updated_on_the_status_of_your_referral_as_we_move_through_the_process_All_communications_will_be_sent_to_the_email_address_you_provided_in_the_previous_form',
                'Thank you for submitting your referral. We will keep you updated on the status of your referral as we move through the process. All communications will be sent to the email address you provided in the previous form',
              )}.`}</BodyMedium>
              <BodyMedium>{`${t(
                'To_track_your_referrals_simply_click_the_button_below',
                'To track your referrals, simply click the button below',
              )}!`}</BodyMedium>
            </>
          ) : (
            <BodyMedium>{`${t(
              'Thank_you_for_submitting_your_referral_to_us_We_appreciate_your_loyalty_to_our_company_A_recruiter_will_be_in_contact_with_your_referral_to_discuss_the_next_steps',
              'Thank you for submitting your referral to us! We appreciate your loyalty to our company. A recruiter will be in contact with your referral to discuss the next steps',
            )}.`}</BodyMedium>
          )}
          {is_tracking_enabled && customer_type !== CUSTOMER_TYPE.CORPORATE && (
            <div className={css.trackReferralButton}>
              <Button
                onClick={() => {
                  onTrackReferrals();
                }}
                className={css.buttonWidth}
                type="primary"
              >
                {t('Track_Referrals', 'Track Referrals')}
              </Button>
            </div>
          )}
        </div>
      ) : (
        <BodyMedium>
          {t(
            'Your_application_has_been_updated_successfully',
            'Your application has been updated successfully',
          )}
        </BodyMedium>
      )}
    </div>
  );
};
